import React, { useCallback } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../Store";
import {
  error,
  noPermissionAlert,
  success,
} from "../../Services/CommonService";
import { useApplyJobMutation } from "../../Store/api/DataApi";

export default function JobItemComponent(props) {
  const {
    id,
    job_title,
    profile_image,
    company_name,
    job_details,
    locations,
    job_ctc,
  } = props?.item;

  const { isAuth, profile } = useSelector((state: RootState) => state.auth);
  const [applyJob] = useApplyJobMutation();

  const handleApply = useCallback(
    (id) => {
      if (isAuth && profile?.lgbt_status === 1) {
        applyJob(id)
          .then((res) => {
            if (res.error) {
              error(res?.error?.data?.error);
            } else {
              success(res?.data?.message);
            }
          })
          .catch((err) => {
            error(err?.error?.data?.error);
          });
      } else if (isAuth && profile?.lgbt_status === 0) {
        noPermissionAlert();
      }
    },
    [applyJob, isAuth, profile]
  );

  return (
    <div className="inner-box my-resume">
      <div className="single-post d-flex flex-row">
        <div className="thumb pr-30">
          {profile_image !== "" && (
            <img
              src={
                process.env.REACT_APP_API_HOST +
                "uploads/recruiter/" +
                encodeURI(profile_image)
              }
              width={120}
              alt={job_title}
            />
          )}
          {/* <img
            src={require("../../Assets/img/comapny-logos/acuity.jpg")}
            width={120}
            alt=""
          /> */}
        </div>
        <div className="details flex-grow">
          <div className="title d-flex flex-row justify-content-between">
            <div className="titles">
              <Link to={`/job-detail/${id}`}>
                <h4>{job_title}</h4>
              </Link>
              <h6>{company_name}</h6>
            </div>
            <ul className="btns">
              <li onClick={() => handleApply(id)}>
                <Link to="#">Apply</Link>
              </li>
            </ul>
          </div>
          <div dangerouslySetInnerHTML={{ __html: job_details }}></div>
          <h5>Job Nature: Full time</h5>
          <p className="address">
            <span className="lnr lnr-map" /> {locations}
          </p>
          <p className="address">
            <span className="lnr lnr-database" /> {job_ctc}
          </p>
        </div>
      </div>
    </div>
  );
}
